import { useLocation, useParams } from 'react-router-dom';
import useUrlAttributes from './useUrlAttributes';

const useHierarchyUrlParams = () => {
  const { search } = useLocation();
  const { containerId } = useParams<{ containerId: string }>();
  const queryString = new URLSearchParams(search);

  const hierarchyRequest: any = { sortBy: ['name'] };

  if (containerId) hierarchyRequest.containerId = containerId;

  const containerRelation = queryString.get('containerRelation');
  if (containerRelation) hierarchyRequest.containerRelation = containerRelation;

  const relation = queryString.get('relation');
  if (relation !== null) hierarchyRequest.relation = relation;

  const connector = queryString.get('connector');
  const sortBy = queryString.getAll('sortBy');
  if (sortBy.length > 0) hierarchyRequest.sortBy = sortBy;

  const recursive = queryString.get('recursive');
  if (recursive !== null)
    hierarchyRequest.recursive = !(recursive === 'false' || recursive === '0');

  const recursionCount = queryString.get('recursionCount');
  if (recursionCount !== null && !Number.isNaN(parseInt(recursionCount, 10)))
    hierarchyRequest.recursionCount = parseInt(recursionCount, 10);

  const criteria = queryString.get('criteria');
  if (criteria !== null) hierarchyRequest.criteria = criteria;

  if (connector !== null) hierarchyRequest.connector = connector;

  const elementtypes = queryString.getAll('elementtypes');
  if (elementtypes.length > 0) hierarchyRequest.elementtypes = elementtypes;
  hierarchyRequest.attributes = useUrlAttributes();

  return hierarchyRequest;
};

export default useHierarchyUrlParams;
